import React, { FunctionComponent } from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import SvgImage from '../../../../shared/components/svg-image';
import { i18n } from '../../../../shared/helpers/i18n';
import { selectConferenceIsOverflow, selectConferenceLimit, selectIsWaitingRoomOverflow } from '../../selectors';
import styles from './styles.css';

enum LimitMessageType {
    Warning = 'Warning',
    Error = 'Error',
}

interface LimitMessageProps {
    type: LimitMessageType;
    title: string;
    text: string;
}
const LimitMessage: FunctionComponent<LimitMessageProps> = ({ type, title, text }) => {
    return (
        <div
            className={cn(styles.limitMessage, {
                [styles.warning]: type === LimitMessageType.Warning,
                [styles.error]: type === LimitMessageType.Error,
            })}
        >
            <SvgImage
                imageName={type === LimitMessageType.Warning ? 'warning' : 'error2'}
                className={styles.limitMessageIcon}
            />
            <div className={styles.limitMessageContent}>
                <div className={styles.limitMessageTitle}>{title}</div>
                <div className={styles.limitMessageText}>{text}</div>
            </div>
        </div>
    );
};

export const ConferenceLimitWarning = () => {
    const conferenceLimit = useSelector(selectConferenceLimit);
    const isWaitingRoomOverflow = useSelector(selectIsWaitingRoomOverflow);
    const conferenceIsOverflow = useSelector(selectConferenceIsOverflow);

    return (
        <>
            {isWaitingRoomOverflow && !conferenceIsOverflow && conferenceLimit ? (
                <LimitMessage
                    type={LimitMessageType.Warning}
                    title={i18n('participants-sidebar', 'conference-limit-warning-title', { count: conferenceLimit })}
                    text={i18n('participants-sidebar', 'conference-limit-warning-text')}
                />
            ) : null}
            {conferenceIsOverflow ? (
                <LimitMessage
                    type={LimitMessageType.Error}
                    title={i18n('participants-sidebar', 'conference-limit-error-title')}
                    text={i18n('participants-sidebar', 'conference-limit-error-text')}
                />
            ) : null}
        </>
    );
};
